<template>
    <div class="grid grid-cols-2 lg:grid-cols-4 gap-4 gap-y-8 lg:gap-8 mb-8">
        <div
            v-for="(csProduct, index) in products"
            :key="index"
        >
            <ProductCard
                :product="csProduct"
                :position="index"
                list="You may also like"
            />
        </div>
    </div>
</template>

<script>
import ProductCard from '~/components/ProductCard';

export default {

    components: {
        ProductCard,
    },

    props: {
        products: {
            type: Array,
            required: true,
        },
        product: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },

};
</script>

<style lang="scss" scoped>
</style>
